/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TwoFactorAuth/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CredentialsAction from './CredentialsAction/index'
import Mechanism from './Mechanism/index'
import React from 'react'
import SignInAction from './SignInAction/index'
import SkipNext from './SkipNext/index'
import Token from './Token/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TwoFactorAuth({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/TwoFactorAuth"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 text="Your account is secured using two-factor authentication."
/>
<Mechanism
  viewPath={`${viewPath}/Mechanism`}
/>
<Token
  viewPath={`${viewPath}/Token`}
/>
<SkipNext
  viewPath={`${viewPath}/SkipNext`}
/>
<div
  data-testid="TwoFactorAuth.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1qbMEd': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<CredentialsAction
  viewPath={`${viewPath}/CredentialsAction`}
/>
<SignInAction
  viewPath={`${viewPath}/SignInAction`}
/>
</div>
{children}
</React.Fragment>)
}